import React from "react";
import { ListStyled, MainIcon } from "../../theme";
import styled from "styled-components";

import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

import { getTranslation } from "../languageProvider";

export const PointDetailEquipment = ({
  equipment,
  Select,
  length,
  index,
  indexPoint,
  pointId,
  SwitchIndex,
  serviceOrder,
}) => {
  const upClickHandler = () => {
    SwitchIndex && index !== 0 && SwitchIndex("up", index, indexPoint, pointId);
  };

  const downClickHandler = () => {
    SwitchIndex &&
      index !== length - 1 &&
      SwitchIndex("down", index, indexPoint, pointId);
  };
  return (
    <ListStyled>
      <MainIcon color={equipment.state.color}>
        <img src={equipment.icon} alt={equipment.serialNumber} />
      </MainIcon>
      <div className="detail" onClick={Select}>
        {equipment.serialNumber}
        <span
          className={`${!equipment.client && "error"}`}
          data-translate="0153"
        >
          {equipment.client ? equipment.client.name : getTranslation("0153")}
          <br />
          {getTranslation("0171")}: {serviceOrder}
        </span>
      </div>
      {SwitchIndex && length > 1 && (
        <UpDownArrowStyled>
          <ArrowDropUpIcon
            onClick={upClickHandler}
            className={index === 0 ? "disable" : ""}
          />
          <ArrowDropDownIcon
            onClick={downClickHandler}
            className={index === length - 1 ? "disable" : ""}
          />
        </UpDownArrowStyled>
      )}
    </ListStyled>
  );
};

const UpDownArrowStyled = styled.div`
  ${(props) => {
    let current = props.theme;
    return `
      display:flex;
      flex-direction:column;
      justify-content: center;
      align-items: center;
      >svg{
        width:30px;
        :hover{
          color:rgba(${current.white});
          background:rgba(${current.green});
        }
      }
    `;
  }}
`;
